import SectionDivider from '@components/profile/teacher/section-divider'
import { useProfileContext } from '@contexts/profile'
import React from 'react'

const TeacherAbout = () => {
  const { profileDetails } = useProfileContext()
  const about = profileDetails?.teacher?.about

  if (!about) return null

  return (
    <>
      <SectionDivider />
      <section className="p-5 lg:p-10">
        <h2 className="inline-block bg-orange text-white font-600 rounded px-3 py-1 mb-4">
          About teacher
        </h2>
        <p className="text-grey-900 text-base whitespace-pre-line leading-relaxed">
          {about}
        </p>
      </section>
    </>
  )
}

export default React.memo(TeacherAbout)
